export default "__VITE_ASSET__Dc$C4QIa__"